export enum VideoIds {
  HeroBanner = "hero-banner",
  Employee = "employee",
}
